import { useEffect } from 'react';
import { Link } from '@tanstack/react-router';

import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

export function NotFoundPage() {
  useEffect(() => {
    const root = document.getElementById('root');
    root?.setAttribute('data-app-notfound', '1');
    return () => root?.removeAttribute('data-app-notfound');
  }, []);

  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-4 py-8">
      <Card className="w-full max-w-md">
        <CardContent className="p-6">
          <p className="text-sm font-semibold text-primary">Seattle transit</p>
          <h1 className="mt-2 font-heading text-2xl font-semibold">Screen not found</h1>
          <p className="mt-2 text-sm leading-6 text-muted-foreground">That screen isn’t part of the schedule board.</p>
          <Button render={<Link to="/" />} className="mt-6 min-h-11">
            Return to bus times
          </Button>
        </CardContent>
      </Card>
    </main>
  );
}
